import { NgModule } from '@angular/core';
import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { AppComponent } from './app.component';
import { DisplayClienteComponent } from './display-cliente/display-cliente.component';
import { DisplayClienteV2Component } from './display-cliente-v2/display-cliente-v2.component';
import { Routes,RouterModule } from '@angular/router';
import { LoginClienteComponent } from './login-cliente/login-cliente.component';
import { GrillaTurnosComponent } from './grilla-turnos/grilla-turnos.component';
import { ListadoEncuestasComponent } from './listado-encuestas/listado-encuestas.component';
import { AbmBannersComponent } from './abm-banners/abm-banners.component';
import { AbmParametrosComponent } from './abm-parametros/abm-parametros.component';
const routes: Routes = [
  { path: '', redirectTo: '/login-cliente', pathMatch: 'full' },
  { path: 'display-cliente', component: DisplayClienteComponent },
  { path: 'display-cliente-v2', component: DisplayClienteV2Component },
  { path: 'login-cliente', component: LoginClienteComponent },
  { path: 'grilla-turnos', component: GrillaTurnosComponent },
  { path: 'listado-encuestas', component: ListadoEncuestasComponent },
  { path: 'abm-banners', component: AbmBannersComponent },
  { path: 'abm-parametros', component: AbmParametrosComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy }]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// E:/R1/Angular/turnero/web-visor-cliente/src/app/app-routing.module.ts